export function parseRelease(value) {
  if (!value || !Number.isSafeInteger(value.version) || value.version <= 0 ||
      !Number.isSafeInteger(value.minimumVersion) || value.minimumVersion < 0 ||
      value.minimumVersion > value.version) return null;
  return value;
}

export function needsRequiredUpdate(currentVersion, release) {
  return currentVersion < release.minimumVersion;
}
